import Client from '@/client'

export default {
  list() {
    return Client.get(`users/`, { params: { query: `(is_active:true){id,name,username}` } })
  },
  create(payload) {
    return Client.post(`users/`, payload)
  },
  retrieve(id) {
    return Client.get(`users/${id}/`)
  },
  update(id, payload) {
    return Client.put(`users/${id}/`, payload)
  },
  set_password(id, payload) {
    return Client.post(`users/${id}/set_password/`, payload)
  },
  patch(id, payload) {
    return Client.patch(`users/${id}/`, payload)
  },
  destroy(id) {
    return Client.delete(`users/${id}/`)
  },
}